<template>
  <div class="col-md-12 p-0 mx-auto">
    <custom-popup
      hide-confirm
      :cons="{ title: 'ایجاد تاریخچه' }"
      v-model="historyModal"
      max-width="1200"
      transition="dialog-bottom-transition"
    >
      <v-card class="p-5">
        <add-history
          v-if="historyModal"
          :reload="
            () => {
              reloadTable(tableProps);
            }
          "
          :id="id"
          :modal="
            () => {
              this.historyModal = false;
            }
          "
        ></add-history>
      </v-card>
    </custom-popup>
    <custom-popup
      max-width="600"
      :cons="{ title: 'توضیحات' }"
      transition="dialog-bottom-transition"
      v-model="showDescrption"
    >
      <v-card class="p-5">
        <div class="p-10">
          <p>مذاکرات انجام شده :</p>
          <p v-html="myDesc"></p>
          <hr />
          <p>موارد پیگیری در تماس بعدی :</p>
          <p v-html="myPurpose"></p>
        </div>
      </v-card>
    </custom-popup>

    <v-card :loading="loading" flat class="p-3 mx-2">
      <div class="mb-4">
        <v-btn @click="historyModal = true" class="submit-btn"
          >ایجاد تاریخچه جدید</v-btn
        >
      </div>

      <terminal-table
        class="col-12"
        :currentPage="datas.current_page"
        :perPage="datas.per_page"
        v-if="isMobile"
        :getData="getData()"
        :pageCount="datas.last_page"
        :options="tableProps"
        :datas="datas"
        :headers="columns"
      ></terminal-table>

      <data-table
        v-else
        :data="datas"
        :columns="columns"
        :debounce-delay="3000"
        :pagination="paginate"
        :orderBy="tableProps.column"
        :orderDir="tableProps.dir"
        :translate="translate"
        :per-page="[10, 25, 50, 100, 500]"
        @on-table-props-changed="reloadTable"
        class="pt-5 mt-5 table-striped text-center table-hover table-responsive-lg table-responsive-md table-responsive-sm table-responsive-xs"
      ></data-table>
    </v-card>
  </div>
</template>

<script>
import { debounce } from "@/custom";
import button from "@/view/pages/button";
import { dataTableProps, RobotAxios } from "@/main";
import AddHistory from "./addHistory";

export default {
  name: "listHistory",
  components: { AddHistory },
  props: {
    id: {
      default: "",
    },
    estate: {
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      historyModal: false,
      showDescrption: false,
      related_id: null,
      datas: {},
      mine: [],
      myRes: [],
      translate: dataTableProps.translate,
      tableProps: dataTableProps.tableProps,
      paginate: dataTableProps.pagination,
      selectedNumber: [],
      translates: [],
      dataId: "",
      adsList: "",
      myDesc: "",
      myPurpose: "",
      nowTime: "",
      columns: [
        {
          label: '<input type="checkbox" id="selectAll">',
          isCheckBox: true,
          transform: (val) => {
            return `<input type="checkbox"  data-id="${val.data.phone}">`;
          },
          orderable: false,
        },
        {
          label: "ردیف",
          transform: (val) => {
            let row = this.datas.current_page - 1;
            row = row * this.datas.per_page;
            return row + val.row + 1;
          },
          orderable: true,
        },
        {
          label: "عنوان ",
          name: "title",
          primary: true,
          orderable: true,
          searchable: true,
        },
        {
          label: "مرحله ",
          name: "step",
          transform(val) {
            return `<span>${
              val.data.step !== null ? val.data.step : "-"
            }</span>`;
          },
          orderable: true,
          searchable: true,
        },
        {
          label: "زمان یادآور",
          name: "remind_date",
          transform(val) {
            return `<span>${
              val.data.remind_date !== null
                ? this.datetime(val.data.remind_date, "datetime")
                : "-"
            }</span>`;
          },

          orderable: true,
          searchable: true,
        },
        {
          label: "زمان آخرین تماس",
          name: "created_at_p",
          transform(val) {
            return `<span>${
              val.data.created_at_p !== null ? val.data.created_at_p : "-"
            }</span>`;
          },
          orderable: true,
          searchable: true,
        },
        // {
        //     label: 'توضیحات',
        //     name: 'description',
        //     transform(val){
        //       return `<p class="text-truncate" style="max-width: 1rem">${val.data.description}</p>`
        //     },
        //     orderable: true,
        //     searchable: true,
        // },
        {
          label: "ثبت کننده",
          name: "user",
          transform(val) {
            return `<p>${
              val.data.user.name + " " + val.data.user.lastName
            }</p>`;
          },
          orderable: true,
          searchable: true,
        },
        {
          label: "مدیریت",
          name: "action",
          component: button,
          event: "actions",
          meta: {
            buttons: [
              {
                name: "desc",
                label: "نمایش توضیحات",
                icon: "list",
                class: "btn-outline-info",
                action: this.actions,
              },
            ],
          },
        },
      ],
      updatedData: [],
      authResult: [],
    };
  },
  methods: {
    getData(query = this.tableProps) {
      this.loading = true;

      this.$api
        .get(`/admin/qr/history`, {
          params: {
            ...query,
            qr_id: this.id,
          },
        })
        .then((response) => {
          this.datas = response.data.data;
        })
        .catch(() => {
          this.$modal.error("خطا", "در دریافت اطلاعات با خطا مواجه‌ شدیم.");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    reloadTable(tableProps) {
      debounce(() => {
        this.getData();
      }, 700);
    },
    actions(data, type) {
      this[type + "Action"](data);
    },
    deleteAction(data) {
      this.$modal
        .yesNo("تایید حذف", "آیا از حذف این تاریخچه اطمینان دارید؟", "neg", "")
        .then((value) => {
          if (value === true) {
            this.$api.delete(`admin/qr/history/${data.id}`).then(() => {
              this.$toast.success("با موفقیت دیتای شما حذف شد.");
            });
          }
        });
    },
    descAction(data) {
      this.showDescrption = true;
      this.myDesc = data.description;
      this.myPurpose = data.purpose;
    },
    showAction: function (data) {
      this.showMore = true;
      this.related_id = data.id;
    },
    // getTimesForNow() {
    //   $.ajax({
    //     url: `${url}/setting/clock`,
    //     fn: this.getTimesForNow,
    //     type: 'GET',
    //     headers: {
    //       "ACCEPT": "application/json",
    //       "Authorization": Token
    //     },
    //     success: (data) => {
    //       this.nowTime = data.data.time_stamp;
    //     }
    //   });
    // }
  },
  computed: {
    isMobile() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          this.getData(this.url);
          return true;
        case "sm":
          this.getData(this.url);
          return true;
        case "md":
          this.getData(this.url);
          return false;
        case "lg":
          this.getData(this.url);
          return false;
        case "xl":
          this.getData(this.url);
          return false;
      }
    },
  },
  mounted() {
    this.getData(this.url);
  },
};
</script>
